import api from "./base-api"
import {buildStateCreateParams} from "./stateCopyParams"


const mcStateApiV2 = api.injectEndpoints({
    endpoints: (build) => ({
        getStateV2MC: build.query({
            query: (data) => {
                return `v2/mc/states/${data.deviceId}/${data.stateId}`
            },
            providesTags: ['UserStates']
        }),
        getStatesByFacebookIdV2MC: build.query({
            query: (facebookId = "") => `v2/mc/states/facebook/${facebookId}`
        }),
        createStateV2MC: build.mutation({
            query: (data) => {
                const {userId, vendorId, game, isDirectCopy, sourceUserId, sourceVendorId, comment, zendeskTicketId, ...body} = data
                const params = buildStateCreateParams({vendorId, isDirectCopy, sourceUserId, sourceVendorId, comment, zendeskTicketId})

                return {
                    url: `v2/mc/states/${game}/${userId}?${params.toString()}`,
                    method: "POST",
                    body: body.body
                }
            },
            invalidatesTags: ['UserStates']
        }),
        clearData: build.mutation({
            query: () => null,
            onQueryStarted: (arg, {dispatch, queryFulfilled}) => {
                dispatch(clearData())
                queryFulfilled(undefined, {data: null})
            },
        }),
        checkMCExist: build.mutation({
            query: (body = {}) => ({
                url: `v2/mc/states/exist`,
                method: "POST",
                body: body
            }),
        }),
        advancedSearchMC: build.mutation({
            query: (body = {}) => ({
                url: `v2/mc/states/advancedSearch`,
                method: "POST",
                body: body
            }),
        }),
    }),
    overrideExisting: false
})

export const {
    useGetStateV2MCQuery,
    useGetStatesByFacebookIdV2MCQuery,
    useCreateStateV2MCMutation,
    clearData,
    useCheckMCExistMutation,
    useAdvancedSearchMCMutation
} = mcStateApiV2
